<template>
    <div class="panel-group">
        <div style="position:relative;background:white;width:300px;height:400px;margin:0 auto;border-radius:10px;padding:10px;margin-top:20px;">

            <div v-if="hasLogin">
                <router-link :to="{ path:'/account'}">
                    <h3 class="glyphicon glyphicon-user">{{lang.navi.account}}</h3>
                </router-link>
            </div>
            <div v-if="!hasLogin">
                <div class="col-xs-12">
                    <h3>{{lang.login.newRegister}}:</h3>
                </div>
                <div class="col-xs-12">
                    <input v-model="registerInfo.email" type="text" :placeholder="lang.login.email" class="form-control" />
                </div>
                <div class="col-xs-12">
                    <input v-model="registerInfo.password" type="password" :placeholder="lang.login.password" class="form-control" />
                </div>
                <div class="col-xs-12">
                    <input v-model="registerInfo.confirmPassword" type="password" :placeholder="lang.login.confirmPassword" class="form-control" />
                </div>
                <div>
                    <div class="col-xs-12"><input name="given-name" v-model="registerInfo.givenName" type="text" :placeholder="lang.login.givenName" class="form-control" /> </div>
                    <div class="col-xs-12"><input name="sur-name" v-model="registerInfo.surName" type="text" :placeholder="lang.login.surName" class="form-control" /> </div>
                    <div class="col-xs-12">
                        <span style="float:right;margin-top:10px;" class="btn btn-primary col-xs-12" @click="createAccount">{{lang.login.register}}</span>
                    </div>
                </div>
            </div>

            <div class="col-xs-12" style="text-align:center;">
                <div style="color:red;font-weight:bold;">{{loginMsg}} </div>
                <div v-if="regOk">
                    <span class="glyphicon glyphicon-arrow-down"></span>
                </div>
            </div>
            <div v-if="!hasLogin">
                <div class="col-xs-12" style="text-align:center;">
                    <h3 class="btn btn-default" @click="goLogin">{{lang.login.login}}</h3>
                </div>
                <div class="col-xs-12" style="text-align:center;padding:10px;">
                    <router-link :to="{ path:'/forgotLogin',query:{test:123}}">
                        <span>{{lang.login.forgotAccountPassword}}</span>
                    </router-link>
                </div>
            </div>
            

        </div>
    </div>
</template>
<script>
   
    export default {
        //props: ["apiClient"],
        data: function () {
            return {
                registerInfo: { email: null, password: null, givenName: null, surName: null, confirmPassword:null },
                loginMsg: "",
                regOk: false
            }
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.registerApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            },
            hasLogin: function () {
                return this.$store.getters.account !== null;
            }
        },
        methods: {
            goLogin: function() {
                this.apiClient.getProfilePrms();
            },
            createAccount: function () {
                var that = this;
                this.regOk = false;
                var passMatch = this.registerInfo.password === this.registerInfo.confirmPassword;
                if (!passMatch) {
                    this.loginMsg = this.lang.register.misMatchPassword;
                    return;
                }

                if (this.registerInfo.email === '' || this.registerInfo.givenName === '' || this.registerInfo.surName === '') {
                    this.loginMsg = this.lang.register.missingValue;
                    return;
                }

                this.apiClient.registerPrms(this.registerInfo,0)
                    .done(function (ret) {
                        if (ret.ok === true) {
                            that.regOk = true;
                            that.registerInfo.password = "";
                            that.registerInfo.email = "";
                            that.registerInfo.confirmPassword = "";
                            that.registerInfo.givenName = "";
                            that.registerInfo.surName = "";
                            that.loginMsg = that.lang.common.success + " " +that.lang.common.pleaseLogin;
                        } else {
                            that.regOk = false;
                            that.registerInfo.confirmPassword = "";
                            that.registerInfo.password = "";
                            that.registerInfo.givenName = "";
                            that.registerInfo.surName = "";
                            that.loginMsg = that.lang.common.fail + " " + that.lang.common.pleaseRetry;
                        }
                    });
            }
        },
        mounted: function () {
        }
    }
</script>